import api from '@/utils/api'

export default {
    getCoaches(params) {
        const queryParams = new URLSearchParams()
        if (params && params.sportId) {
            queryParams.append('sportId', params.sportId)
        }
        if (params && params.sportClassId) {
            queryParams.append('sportClassId', params.sportClassId)
        }
        if (params && params.startDate) {
            queryParams.append('startDate', params.startDate)
        }
        if (params && params.endDate) {
            queryParams.append('endDate', params.endDate)
        }
        const queryString = queryParams.toString()
        return api.get(`metrics/payments/coaches${queryString ? `?${queryString}` : ''}`)
    },
    getMemberships(params) {
        const queryParams = new URLSearchParams()
        if (params && params.sportId) {
            queryParams.append('sportId', params.sportId)
        }
        if (params && params.sportClassId) {
            queryParams.append('sportClassId', params.sportClassId)
        }
        if (params && params.startDate) {
            queryParams.append('startDate', params.startDate)
        }
        if (params && params.endDate) {
            queryParams.append('endDate', params.endDate)
        }
        const queryString = queryParams.toString()
        return api.get(`metrics/memberships/users${queryString ? `?${queryString}` : ''}`)
    }
}
